import React from 'react';
import { connect } from 'react-redux';
import { RefreshIndicator } from 'material-ui';
import ExecutionEnvironment from 'exenv';
import PropTypes from 'prop-types';

import TripListRenderer from './TripListRenderer';
import TripListFilters from './TripListFilters';
import { setValue } from '../../store/actions/TripsActions';
import styles from './styles.scss';
import TripDetailsRenderer from './TripDetailsRenderer';

@connect(state => ({
  viewport: state.Responsive.get('viewport'),
  windowHeight: state.Responsive.get('windowHeight'),
  filterNeed: state.Trips.get('filter'),
}))
export default class Trips extends React.Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired,
    viewport: PropTypes.string.isRequired,
    match: PropTypes.shape({
      params: PropTypes.object,
    }).isRequired,
    windowHeight: PropTypes.number.isRequired,
    filterNeed: PropTypes.string.isRequired,
  }

  constructor(props) {
    super(props);

    this.state = {
      onClient: false,
    };
  }

  componentWillMount() {
    this.setState({ onClient: ExecutionEnvironment.canUseDom });
  }

  componentDidMount() {
    this.setState({ onClient: true }); // eslint-disable-line
    this.setSelectedUser();
  }

  setSelectedUser = () => {
    const userRE = /\?user=([\w=]+)/;
    const match = userRE.exec(location.search);
    const selectedUser = match ? match[1] : 'all';

    this.props.dispatch(setValue('selectedUser', selectedUser));
  }

  render() {
    const {
      viewport, match: {
        params: { tripId: activeTrip },
      }, windowHeight, filterNeed,
    } = this.props;
    const { onClient } = this.state;
    const top = ((windowHeight - 161) / 2) + 161;

    const ActiveTrip = <TripDetailsRenderer activeTrip={activeTrip} />;

    if (viewport !== 'desktop' && activeTrip) {
      return ActiveTrip;
    }

    const loadingEl = (<div>
      <TripListFilters filter={filterNeed} numFiltered={0} numTrips={0} />
      <RefreshIndicator top={top} left={277} status='loading' />
    </div>);

    return (<div className={styles.container}>
      <div className={styles.list}>
        {onClient ? <TripListRenderer
          activeTrip={activeTrip}
          loadingEl={loadingEl}
        /> : loadingEl}
      </div>
      <div className={styles.detail}>{activeTrip ? ActiveTrip : null}</div>
    </div>);
  }
}



// WEBPACK FOOTER //
// /src/components/Trips/Trips.js